<template>
  <el-dialog
    title="Booking Online"
    :visible.sync="dialogVisible"
    width="90%"
    :before-close="handleClose"
    :append-to-body="true"
    :close-on-click-modal="false"
  >
    <div>
      <div class="wrap">
        <div class="colorWrap">
          <div
            v-for="(item, index) in colorTitleList"
            :key="index"
            :style="{ color: item.color }"
            :class="[
              index != colorTitleList.length - 1 ? 'color-item color' : 'color',
              checkTabKey == item.id ? 'tab_active' : '',
            ]"
            @click="() => checkTab(item)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <div v-if="checkTabKey != null">
        <div class="select-date-wrap">
          <span style="width: 55px">Date：</span>
          <el-date-picker
            v-model="book_date"
            :picker-options="expireTimeOPtion"
            type="date"
            format="MM/dd/yyyy"
            placeholder="select"
            value-format="yyyy-MM-dd"
            @change="changeDate"
          >
          </el-date-picker>
        </div>

        <div v-if="book_date">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="14" :lg="14" :xl="14">
              <div v-if="block && block.block_date" class="block_wrap">
                <div class="block_title">BLOCK DAY</div>
                <div class="block_remark">{{block.block_date}}</div>
              </div> 
              <div v-else>
                <div class="time-wrap" v-if="roomListInfo.length">
                  <div
                    v-for="(item, index) in roomListInfo"
                    :key="index"
                    class="time-sigle"
                  >
                    <div
                      v-for="(citem, cindex) in item.children"
                      :key="cindex"
                      :class="[
                        citem.id == checkTimeId
                          ? 'active time-title'
                          : 'time-title',
                        citem.is_calendar == 1 ? 'is_calendar' : '',
                      ]"
                      :style="{ color: color }"
                      @click="() => checkTime(citem, item)"
                    >
                      {{ item.name }} {{ citem.time }}
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="LEVEL-DETAIL level-big is-hidden-tablet-992"
                v-if="detail"
                :style="{ background: color ? color : '' }"
              >
                <div class="level-name">{{ detail.title }}</div>
                <div class="level-price">${{ detail.price }}</div>
                <div class="html_info" v-html="detail.desc"></div>
                <div class="HR"></div>
                <div class="html_info" v-html="detail.price_info"></div>
                <div class="HR"></div>
                <div class="html_info" v-html="detail.enable_info"></div>
                <div class="HR"></div>
                <div class="">
                  {{ detail.remark }}
                </div>
              </div>
              <el-form
                ref="form"
                :rules="rules"
                :model="form"
                label-width="120px"
              >
                <el-form-item prop="first_name" label="First name: ">
                  <el-input
                    size="medium"
                    v-model="form.first_name"
                    placeholder="First name"
                  />
                </el-form-item>
                <el-form-item prop="last_name" label="Last name: ">
                  <el-input
                    size="medium"
                    v-model="form.last_name"
                    placeholder="Last name"
                  />
                </el-form-item>
                <el-form-item prop="phone" label="Phone：">
                  <el-input
                    size="medium"
                    v-model="form.phone"
                    @input="formatPhoneNumberInfo"
                    placeholder="(201)555-0123"
                    maxlength="13"
                  />
                </el-form-item>
                <el-form-item prop="email" label="Email：">
                  <el-input size="medium" v-model="form.email" />
                </el-form-item>
                <el-form-item prop="payment_id" label="Payment: ">
                  <el-radio-group size="medium" v-model="form.payment_id">
                    <el-radio-button
                      v-for="(item, index) in paymentInfo"
                      :key="index"
                      :label="item.id"
                      :value="item.id"
                      >{{ index == 0 ? 'deposit ': 'pay in full '}} $ {{ item.price }}</el-radio-button
                    >
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  prop="party_provide_id"
                  class="label_100 provide"
                  label="Would you like us to provide cups, plates, and utensils?"
                >
                  <el-radio-group size="medium" v-model="form.party_provide_id">
                    <el-radio
                      v-for="(item, index) in provideInfo"
                      :key="index"
                      :label="item.id"
                      :value="item.id"
                      >{{ item.title }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  prop="tablecloth_color_id"
                  label="Select tablecloth color:"
                  class="label_100"
                >
                  <el-radio-group
                    size="medium"
                    v-model="form.tablecloth_color_id"
                  >
                    <el-radio
                      v-for="(item, index) in tableclothColorInfo"
                      :key="index"
                      :label="item.id"
                      :value="item.id"
                      >{{ item.color }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  prop="birthday_child_name"
                  label="Birthday Child's Name："
                  class="child_name is-hidden-tablet label_100"
                >
                  <el-input
                    size="medium"
                    v-model="form.birthday_child_name"
                    placeholder="Birthday Child's Name"
                  />
                </el-form-item>
                <el-form-item
                  prop="birthday_child_name"
                  label="Birthday Child's Name："
                  class="child_name is-hidden-mobile"
                >
                  <el-input
                    size="medium"
                    v-model="form.birthday_child_name"
                    placeholder="Birthday Child's Name"
                  />
                </el-form-item>
                <el-form-item prop="remark" label="Remark：" class="label_80">
                  <el-input
                    size="medium"
                    type="textarea"
                    v-model="form.remark"
                    placeholder="order's remark ..."
                  />
                </el-form-item>
              </el-form>
            </el-col>
            <el-col
              :xs="10"
              :sm="10"
              :md="10"
              :lg="10"
              :xl="10"
              class="is-hidden-mobile-992"
            >
              <div class="LEVEL-DETAIL level-big" v-if="detail" :style="{ background: color ? color : '' }">
                <div class="level-name">{{ detail.title }}</div>
                <div class="level-price">${{ detail.price }}</div>
                <div class="html_info" v-html="detail.desc"></div>
                <div class="HR"></div>
                <div class="html_info" v-html="detail.price_info"></div>
                <div class="HR"></div>
                <div class="html_info" v-html="detail.enable_info"></div>
                <div class="HR"></div>
                <div class="">
                  {{ detail.remark }}
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">Close</el-button>
      <el-button type="primary" @click="submit" :loading="loading">Booking</el-button>
    </span>
  </el-dialog>
</template>

<script>
import moment from "moment";
import moment_timezone from 'moment-timezone';
import {
  colorTypeList,
  tableclothColor,
  provide,
  roomList,
  addBook,
  payment,
  partyPackageDetail,
  bookDetail,
  bookConfig,
} from "@/server/book.js";
export default {
  props: {
    dialogVisible: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      loading: false,
      book_date: null,
      expireTimeOPtion: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() > Date.now() + (180 - 1) * 8.64e7;
        },
      },
      WarningVisible: false,
      form: {
        first_name: "",
        last_name: "",
        phone: "",
        email: "",
        payment_id: [],
        party_provide_id: null,
        tablecloth_color_id: null,
        birthday_child_name: "",
        remark: "",
      },
      rules: {
        first_name: [
          {
            required: true,
            trigger: "blur",
            message: "First name is required.",
          },
        ],
        last_name: [
          {
            required: true,
            trigger: "blur",
            message: "Last name is required.",
          },
        ],
        phone: [
          {
            required: true,
            trigger: "change",
            validator: this.validatePhone
          },
        ],
        email: [
          {
            required: true,
            type: "email",
            trigger: "blur",
            message: "Please input correct email address.",
          },
        ],
        payment_id: [{ required: true, trigger: "blur", message: "please select one from above" }],
        party_provide_id: [{ required: true, trigger: "blur", message: "please select one from above" }],
        tablecloth_color_id: [{ required: true, trigger: "blur", message: "please select one from above" }],
        birthday_child_name: [{ required: true, trigger: "blur", message: "birthday child name is required" }],
      },
      block: null,
      roomListInfo: [],
      checkId: null,
      checkTimeId: null,
      colorTitleList: [],
      checkTabKey: null,
      color: null,
      provideInfo: [],
      tableclothColorInfo: [],
      paymentInfo: [],
      cancel_reason: null,
      detail: null,
      colorOrgList: ["#faca49", "#de4c50", "#5c7dce"],
    };
  },
  async created() {
    var width = window.innerWidth;
    console.log("width", width);
    var nowDate = new Date();
    // this.book_date = moment(nowDate).format("YYYY-MM-DD");
    this.getColorTypeList();
    // this.getTableclothColor();
    // this.getBookConfig();
  },
  methods: {
    formatPhoneNumberInfo(value) {
      const digits = value.replace(/\D/g, '');
      if(digits.length > 6) {
        this.form.phone = `(${digits.slice(0, 3)})${digits.slice(3, 6)}-${digits.slice(6)}`;
      } else if(digits.length > 3 && digits.length <= 6) {
        this.form.phone = `(${digits.slice(0, 3)})${digits.slice(3)}`;
      } else {
        this.form.phone = digits;
      }
    },
    handleInput(value) {
      var numReg = /^[0-9]*$/;
      var lastText = value.substring(value.length - 1, value.length);
      if (!numReg.test(lastText)) {
        var lastValue = this.formatPhoneNumber(
          value.substring(0, value.length - 1)
        );
        this.form.phone = lastValue;
      } else {
        this.form.phone = this.formatPhoneNumber(value);
      }
    },
    validatePhone(rule, value, callback) {
      if (value && value.length < 13) {
        callback(new Error('Please check your phone number.'));
      }
      if(!value) {
        callback(new Error('phone number is required'));
      }
      callback();
    },
    formatPhoneNumber(phoneNumber) {
      if (
        phoneNumber.length < 5 &&
        phoneNumber[0] == "(" &&
        phoneNumber[phoneNumber.length - 2] != ")" &&
        phoneNumber[phoneNumber.length - 1] != ")"
      ) {
        phoneNumber = `(${phoneNumber.substring(
          1,
          phoneNumber[phoneNumber.length - 1]
        )})`;
      }
      phoneNumber = phoneNumber
        .replace("(", "")
        .replace(")", "")
        .replace("-", "");

      if (phoneNumber.length > 3 && phoneNumber.length <= 6) {
        var num1 = phoneNumber.substring(0, 3);
        var num2 = phoneNumber.substring(3, phoneNumber.length);
        return `(${num1})${num2}`;
      } else if (phoneNumber.length <= 3 && phoneNumber.length > 0) {
        return `(${phoneNumber})`;
      } else if (phoneNumber.length == 0) {
        return "";
      } else {
        var num1 = phoneNumber.substring(0, 3);
        var num2 = phoneNumber.substring(3, 6);
        var num3 = phoneNumber.substring(6, phoneNumber.length);
        return `(${num1})${num2}-${num3}`;
      }
    },
    changeDate(value) {
      // var date = moment(value).format("YYYY-MM-DD");
      var date = moment_timezone.tz(value,'US/Mountain').format("YYYY-MM-DD");
      this.book_date = date;
      this.getRoomList(this.checkTabKey);
      this.getBookConfig();
      this.checkId = null;
      this.checkTimeId = null;
    },
    async getColorTypeList() {
      try {
        const { status, data } = await colorTypeList({});
        if (status == 0) {
          for (let i = 0; i <= data.items.length - 1; i++) {
            data.items[i].color = data.items[i].bg_color ? data.items[i].bg_color : this.colorOrgList[(i + 1) % 3];
          }
          this.colorTitleList = data.items;
          // this.checkTabKey = data[0].key;
          // this.color = data[0].color;
          // this.getRoomList(data[0].key);
        }
      } catch (error) {}
    },
    async getBookConfig() {
      try {
        const { status, data } = await bookConfig({
          party_package_id: this.checkTabKey,
          book_date: this.book_date,
        });
        if (status == 0) {
          this.tableclothColorInfo = data.tablecloth_color;
          this.provideInfo = data.party_provide;
        }
      } catch (error) {}
    },
    async getRoomList(params) {
      this.roomListInfo = [];
      this.block = null;
      try {
        const { status, data } = await roomList({
          party_package_id: params,
          book_date: this.book_date,
        });
        if (status == 0) {
          // this.roomListInfo = data;
          for (let i = 0; i <= data.items.length - 1; i++) {
            data.items[i].children = [];
            for (let j = 0; j <= data.items[i].room_times.length - 1; j++) {
              data.items[i].children.push({
                id: data.items[i].room_times[j].id,
                is_calendar: data.items[i].room_times[j].is_calendar,
                time: data.items[i].room_times[j].time_text,
              });
            }
          }
          this.block = data.block;
          this.roomListInfo = data.items;
        }
      } catch (error) {}
    },
    // checkTab
    checkTab(item) {
      this.detail = null;
      this.color = item.color;
      this.checkTabKey = item.id;
      this.paymentInfo = item.payment;
      this.getRoomList(item.id);
      this.getBookConfig();
      this.detail = item;
    },
    handleClose() {
      this.close();
      this.$parent.closeDialog();
    },
    checkTime(citem, item) {
      if (citem.is_calendar != 1) {
        this.checkId = item.id;
        this.checkTimeId = citem.id;
      }
    },
    close() {
      this.form = {
        first_name: "",
        last_name: "",
        phone: "",
        email: "",
        payment_id: [],
        party_provide_id: null,
        tablecloth_color_id: null,
        birthday_child_name: "",
        remark: "",
      };
      this.checkId = null;
      this.checkTimeId = null;
      this.checkTabKey = null;
      this.roomListInfo = [];
      this.color = null;
      this.detail = null;
    },
    async submit() {
      if (this.checkTabKey == null) {
        this.$message.warning("Select Type");
        return;
      }
      if (!this.book_date) {
        this.$message.warning("Select Date");
        return;
      }
      if (!this.checkTimeId) {
        this.$message.warning("Select Room");
        return;
      }
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          try {
            var params = {
              book_date: this.book_date,
              party_package_id: this.checkTabKey,
              room_id: this.checkId,
              room_time_id: this.checkTimeId,
              ...this.form,
            };
            const { status, data, msg } = await addBook(params);
            if (status == 0) {
              this.$message.success("success");
              this.close();
              this.$parent.closeDialog();
              this.$confirm(
                `Booking for party on date ${data.book_date} ${data.time_text} requires a deposit payment of $${data.pay_price} to complete the booking. After payment is completed, a confirmation email will be sent to ${data.email}.`,
                "PayInfo",
                {
                  confirmButtonText: "Pay",
                  cancelButtonText: 'Cancel',
                }
              )
                .then(() => {
                  window.open(data.pay_url);
                })
                .catch(() => {});
              // this.$alert(
              //   `Booking for party on date ${data.book_date} ${data.time_text} requires a pre order payment of $${data.pay_price} to complete the booking. After payment is completed, a booking email will be sent to ${data.email}.`,
              //   "PayInfo",
              //   {
              //     confirmButtonText: "Pay",
              //     callback: (action) => {
              //       window.open(data.pay_url);
              //     },
              //   }
              // );
            } else {
              this.$message.error(msg);
            }
            this.loading = false;
          } catch (error) {}
        }
      });
    },
  },
};
</script>

<style scoped>
.select-date-wrap {
  display: flex;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 10px;
}
.wrap {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 6px;
}
.colorWrap {
  width: fit-content;
  display: flex;
  justify-content: flex-end;
  border: 1px solid #dee0e7;
  border-radius: 4px;
}
.color-item {
  border-right: 1px solid #dee0e7;
}
.color {
  padding: 8px;
  cursor: pointer;
  font-size: 16px;
}
.time-wrap {
  display: flex;
  border: 1px solid #e2e2e2;
  padding: 10px 8px;
  margin-bottom: 10px;
}
.time-sigle {
}
.time-title {
  border: 1px solid #e7e6e6;
  padding: 4px;
  margin: 8px 4px;
  cursor: pointer;
  font-weight: 500;
  font-size: 13px;
}
.active {
  color: #fff !important;
  background: #409eff;
}
/deep/ .el-form-item__label {
  width: 100px !important;
}
/deep/ .el-form-item__content {
  margin-left: 100px !important;
}
.label_100 /deep/ .el-form-item__label {
  width: 100% !important;
  text-align: left;
}
.label_100 /deep/ .el-form-item__content {
  margin-left: 0px !important;
}
.provide /deep/ .el-radio {
  display: block;
}
.label_100 /deep/ .el-radio {
  padding: 10px 0;
}
.level-big {
  background: linear-gradient(-45deg, #de4c50, #f28859);
}
.LEVEL-DETAIL {
  color: #fff;
  padding: 16px;
  border-radius: 10px;
  box-shadow: 9px 9px 19px #c9c9c9, -9px -9px 19px #fff;
}
.level-name {
  font-size: 32px;
  line-height: 1;
  margin: 0.4em 0;
}
.HR {
  margin: 16px -0.25em;
  border: 1px solid;
}
.LEVEL-DETAIL div {
  line-height: 20px;
  white-space: pre-line;
}
/deep/ .el-calendar-table:not(.is-range) td.next,
.el-calendar-table:not(.is-range) td.prev {
  pointer-events: none;
}
/deep/ .el-calendar-table:not(.is-range) td.next {
  pointer-events: none;
}
/deep/ .el-calendar-table:not(.is-range) td.prev {
  pointer-events: none;
}
/deep/ .el-calendar-table:not(.is-range) td.current {
  pointer-events: none;
}
.book_btn {
  pointer-events: auto;
}
/deep/ .el-calendar__button-group {
  display: none;
}
.calendar-wrap /deep/ .el-calendar__header {
  display: none;
}
/deep/ .el-calendar-table .el-calendar-day {
  height: auto !important;
  padding: 0px !important;
}
.calendar-wrap /deep/ .el-button {
  padding: 5px 11px;
}
.query-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
}
.time-area {
  min-height: 40px;
  padding: 4px;
}
.book-area {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 5px 0;
  border-top: 1px solid #f2f6fc;
}
.date {
  margin: 0 10px;
}
.tab_active {
  background: #409eff;
  color: #fff !important;
}
.is_calendar {
  cursor: not-allowed;
  background: #eee !important;
  color: #666 !important;
}
.html_info {
  white-space: pre-line;
}
.party {
  padding: 8px;
  margin: 1px;
  color: #fff;
  cursor: pointer;
  pointer-events: auto;
}
.level-small {
  background: linear-gradient(-45deg, #f36c31, #faca49);
}
.party_detail_wrap div {
  margin-bottom: 10px;
}
.flex_wrap {
  display: flex;
}
.flex_wrap div {
  flex: 1;
}
.mb-10 {
  margin-bottom: 10px;
}
.label_80 /deep/ .el-form-item__label {
  width: 80px !important;
}
.label_80 /deep/ .el-form-item__content {
  margin-left: 80px !important;
}
@media screen and (max-width: 768px) {
  .is-hidden-mobile {
    display: none !important;
  }
}
@media screen and (max-width: 992px) {
  .is-hidden-mobile-992 {
    display: none !important;
  }
}

@media screen and (min-width: 769px), print {
  .is-hidden-tablet {
    display: none !important;
  }
  .child_name /deep/ .el-form-item__label {
    width: 180px !important;
  }
  .child_name /deep/ .el-form-item__content {
    margin-left: 180px !important;
  }
}
@media screen and (min-width: 993px), print {
  .is-hidden-tablet-992 {
    display: none !important;
  }
  .child_name /deep/ .el-form-item__label {
    width: 180px !important;
  }
  .child_name /deep/ .el-form-item__content {
    margin-left: 180px !important;
  }
}
.block_wrap {
  height: 120px;
  color: white;
  background: #9FA0A4;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}
.block_title {
  font-size: 20px;
  margin-bottom: 10px;
}
.block_tips {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/Book.vue